import { Component, OnInit, AfterViewInit, Inject } from '@angular/core';
import { HomeTabsEnum, HomeSubtabsEnum, SessionService, ConstantsService } from '@app/base/core';
import { BuilderService } from '@app/modules/builder/base';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-request',
  templateUrl: './request.component.html',
  styleUrls: ['./request.component.css']
})
export class RequestComponent implements OnInit, AfterViewInit {
  public activeTabEnum: typeof HomeTabsEnum = HomeTabsEnum;
  public activeSubtabsEnum: typeof HomeSubtabsEnum = HomeSubtabsEnum;
  subdivisionActive = false;
  mainsActive = false;
  public routeSubscription: any;
  serviceActive = true;
  public flag: boolean;
  public bcaId;
  public bcaStatus;
  public url;
  public subscription: Subscription;
  public grId: number;
  public navigateTo = 'service';
  public routeId: number;
  bcaAgreementsActive = false;

  // constructor
  constructor(public builderSvc: BuilderService, @Inject(Router) private router: Router,
    public sessionSvc: SessionService, public route: ActivatedRoute, public constSvc: ConstantsService) {
     this.subscription = this.router.events.subscribe((event) => {
      this.grId = this.route.snapshot.params.id;
      this.bcaId = this.route.snapshot.params.bcaId;
      this.bcaStatus = this.route.snapshot.params.bcaStatus;
      if (event instanceof NavigationEnd && event.id === 1) {
        this.flag = true;
        this.url =  event.url;
        this.routeId = 2;
        const urlArray = this.url.split('/');
       if (urlArray.indexOf('main') > - 1) {
        this.navigateToRoute('main');
       } else if (urlArray.indexOf('service') > -1) {
         this.navigateToRoute('service');
       } else if (urlArray.indexOf('bca-agreements') > -1) {
        this.navigateToRoute('bca-agreements');
      } else {
        this.navigateToRoute('subdivision');
      }
  } else if (event instanceof NavigationEnd && event.id !== 1 && !event.url.endsWith('service')) {
    this.flag = false;
      }
    if (event instanceof NavigationEnd && event.id !== 1 ) {
        if (this.router.url.endsWith(String(this.grId)) &&  (event.id === this.routeId + 1 ) ) {
          this.router.navigate([
            this.sessionSvc.paramLdc.toLowerCase(),
            'builder',
            'home'
          ]);
        } else if (event.url.endsWith('service')) {
           this.routeId = event.id;

        }
      }
});
  }

  // used to initialise servces
  ngOnInit() {
    this.routeSubscription = this.route.params.subscribe(params => {

      if (params['id']) {
        this.grId = (params['id']);
      }
      if (params['bcaId']) {
        this.bcaId = (params['bcaId']);
      }

    });

if (this.flag === false) {
  this.navigateToRoute('service');
}

  }
  ngAfterViewInit(): void {
  }

  // used to unsubscribe to services
  ngOnDestroy() {
  this.subscription.unsubscribe();
  }

  // used to navigate between sub tabs
  navigateToRoute(navigateStr: string) {
    const substr: number = this.router.url.indexOf('request') + 7;
    const str = this.router.url.slice(0, substr);
    if (navigateStr === this.constSvc.main) {
      this.mainsActive = true;
      this.subdivisionActive = false;
      this.serviceActive = false;
      this.bcaAgreementsActive = false;
    } else if (navigateStr === this.constSvc.service) {
      this.mainsActive = false;
      this.subdivisionActive = false;
      this.serviceActive = true;
      this.bcaAgreementsActive = false;
    } else if (navigateStr === this.constSvc.bcaAgreements) {
      this.mainsActive = false;
      this.subdivisionActive = false;
      this.serviceActive = false;
      this.bcaAgreementsActive = true;
    } else {
      this.mainsActive = false;
      this.subdivisionActive = true;
      this.serviceActive = false;
      this.bcaAgreementsActive = false;
    }
    if (this.bcaId) {
      this.router.navigate([str + '/' + this.grId  + '/' + this.bcaId + '/' + navigateStr]);
    } else {
      this.router.navigate([str + '/' + this.grId  + '/' + navigateStr ]);
    }

  }
 }
